import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, Transition as _Transition, withCtx as _withCtx, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import _imports_0 from '../assets/moneyHelper.png';
const _hoisted_1 = { class: "centered mt-10" };
const _hoisted_2 = { class: "anchor-bottom centered" };
import { ref, onMounted, onUnmounted } from 'vue';
import { useRouter } from 'vue-router';
import { useAuth } from '@/composables/useAuth';
import { useContent } from '@/composables/useContent';
import FinancialFitnessBars from './elements/FinancialFitnessBars.vue';
import FinancialFitnessScore from './elements/FinancialFitnessScore.vue';
import HeaderBlock from './elements/HeaderBlock.vue';
import MGButton from './elements/MGButton.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'FinancialFitnessResultsPage',
    setup(__props) {
        const router = useRouter();
        useAuth();
        const { generateFinancialFitness, clearFinancialFitness } = useContent();
        const financialFitness = ref({ score: 0, started: 0, dayToDay: 0, security: 0, future: 0 });
        const loaded = ref(false);
        let interval = null;
        function onLoad() {
            generateFinancialFitness(null, true);
            generateFinancialFitness((fitness) => {
                if (interval) {
                    clearInterval(interval);
                }
                financialFitness.value = fitness;
                loaded.value = true;
                clearFinancialFitness();
            });
            if (!loaded.value) {
                interval = setInterval(() => {
                    const min = 0;
                    const max = 3;
                    financialFitness.value.score += Math.round(Math.random() * (max - min) + min);
                    financialFitness.value.started += Math.round(Math.random() * (max - min) + min);
                    financialFitness.value.dayToDay += Math.round(Math.random() * (max - min) + min);
                    financialFitness.value.security += Math.round(Math.random() * (max - min) + min);
                    financialFitness.value.future += Math.round(Math.random() * (max - min) + min);
                    if (financialFitness.value.score > 100) {
                        financialFitness.value.score = 0;
                    }
                    if (financialFitness.value.started > 100) {
                        financialFitness.value.started = 0;
                    }
                    if (financialFitness.value.dayToDay > 100) {
                        financialFitness.value.dayToDay = 0;
                    }
                    if (financialFitness.value.security > 100) {
                        financialFitness.value.security = 0;
                    }
                    if (financialFitness.value.future > 100) {
                        financialFitness.value.future = 0;
                    }
                }, 100);
            }
        }
        function reTakeSurvey() {
            router.push({ path: '/FinancialFitness' });
        }
        function viewHistory() {
            router.push({ path: '/FinancialFitnessHistory' });
        }
        onMounted(() => {
            onLoad();
        });
        onUnmounted(() => {
            if (interval) {
                clearInterval(interval);
            }
        });
        return (_ctx, _cache) => {
            const _component_v_divider = _resolveComponent("v-divider");
            const _component_v_col = _resolveComponent("v-col");
            const _component_v_row = _resolveComponent("v-row");
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createVNode(HeaderBlock, { title: "Financial Fitness Survey" }),
                _createVNode(_Transition, null, {
                    default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_1, [
                            _createVNode(FinancialFitnessScore, {
                                mini: true,
                                score: financialFitness.value.score,
                                dayToDay: financialFitness.value.dayToDay,
                                future: financialFitness.value.future,
                                security: financialFitness.value.security,
                                started: financialFitness.value.started
                            }, null, 8, ["score", "dayToDay", "future", "security", "started"]),
                            _cache[0] || (_cache[0] = _createElementVNode("p", { class: "mt-4" }, "Thanks for taking the financial fitness survey. Powered by Money Helper. Your overall score is above and the breakdown of your progress is below.", -1)),
                            _createVNode(FinancialFitnessBars, {
                                dayToDay: financialFitness.value.dayToDay,
                                future: financialFitness.value.future,
                                security: financialFitness.value.security,
                                started: financialFitness.value.started
                            }, null, 8, ["dayToDay", "future", "security", "started"])
                        ])
                    ]),
                    _: 1
                }),
                _createElementVNode("div", _hoisted_2, [
                    _createVNode(MGButton, {
                        text: "Retake the Survey",
                        onClick: reTakeSurvey
                    }),
                    _createVNode(MGButton, {
                        text: "View my previous scores",
                        textOnly: "",
                        stacked: "",
                        noCaps: "",
                        onClick: viewHistory
                    }),
                    _createVNode(_component_v_divider, { class: "mt-3" }),
                    _createVNode(_component_v_row, { class: "footerInfo" }, {
                        default: _withCtx(() => [
                            _createVNode(_component_v_col, { cols: "4" }, {
                                default: _withCtx(() => _cache[1] || (_cache[1] = [
                                    _createElementVNode("img", { src: _imports_0 }, null, -1)
                                ])),
                                _: 1
                            }),
                            _createVNode(_component_v_col, null, {
                                default: _withCtx(() => _cache[2] || (_cache[2] = [
                                    _createTextVNode("Helping people to improve their financial wellbeing and build a better, more confident future.")
                                ])),
                                _: 1
                            })
                        ]),
                        _: 1
                    })
                ])
            ], 64));
        };
    }
});
